module.exports = __webpack_public_path__ + "static/media/issue.b5b53fb2.svg";